var bn='250725-0642';export default bn;